module.exports = __webpack_public_path__ + "static/media/rose2.093284f6.jpeg";